import { SCREEN_NAME } from 'constants/index';
import { sendUIEvent } from 'services/analytics';

// https://data-portal.internal.atlassian.com/analytics/registry/71739
const trackLearnMoreAboutKudosClick = () => {
  sendUIEvent({
    action: 'clicked',
    actionSubject: 'link',
    source: SCREEN_NAME.PROFILE,
    actionSubjectId: 'learnMoreAboutKudos',
    isPersonalView: true,
  });
};

export { trackLearnMoreAboutKudosClick };
